import * as angular from "angular";
import * as _ from "lodash"
import {SplitService} from "./split-service.service";
import {METERS_PER_FOOT, METERS_PER_KILOMETER, METERS_PER_MILE} from "../utils/distance-unit.util";

export class BringozUnitConversionService {

  constructor(private splitService: SplitService) {
  }


  //////////////////////////////// PRICE ////////////////////////////////

  pricePerMeterToSmallUnit(pricePerMeter: number) {
    if(!_.isNumber(pricePerMeter)){
      return ;
    }

    const distanceConfig = this.splitService.getSiteDistanceLargeUnit(true)
    return distanceConfig === 'MI' ? this.pricePerMeterToPricePerFeet(pricePerMeter) : pricePerMeter;
  }

  pricePerMeterToLargeUnit(pricePerMeter: number) {
    if(!_.isNumber(pricePerMeter)){
      return ;
    }
    const distanceConfig = this.splitService.getSiteDistanceLargeUnit(true)
    return distanceConfig === 'MI' ? this.pricePerMeterToPricePerMile(pricePerMeter) : this.pricePerMeterToPricePerKm(pricePerMeter);
  }

  pricePerMeterToPricePerKm(pricePerMeter: number) {
    if(!_.isNumber(pricePerMeter)){
      return ;
    }

    return pricePerMeter * METERS_PER_KILOMETER;
  }

  pricePerMeterToPricePerFeet(pricePerMeter: number) {
    if(!_.isNumber(pricePerMeter)){
      return ;
    }
    return pricePerMeter * METERS_PER_FOOT;
  }

  pricePerMeterToPricePerMile(pricePerMeter: number) {
    if(!_.isNumber(pricePerMeter)){
      return ;
    }
    return pricePerMeter * METERS_PER_MILE;
  }

  pricePerSmallSiteUnitToMeter(price){
    if(!_.isNumber(price)){
      return ;
    }

    const distanceConfig = this.splitService.getSiteDistanceLargeUnit(true)

    return distanceConfig === 'MI' ? this.pricePerFootToMeter(price) : price;
  }

  pricePerLargeSiteUnitToMeter(price){
    if(!_.isNumber(price)){
      return ;
    }

    const distanceConfig = this.splitService.getSiteDistanceLargeUnit(true)

    return distanceConfig === 'MI' ? this.pricePerMileToMeter(price) : this.pricePerKmToMeter(price);
  }


  pricePerFootToMeter(pricePerFoot){
    if(!_.isNumber(pricePerFoot)){
      return ;
    }

    return pricePerFoot / METERS_PER_FOOT;
  }

  pricePerKmToMeter(pricePerKm){
    if(!_.isNumber(pricePerKm)){
      return ;
    }

    return pricePerKm / METERS_PER_KILOMETER;
  }

  pricePerMileToMeter(pricePerMile){
    if(!_.isNumber(pricePerMile)){
      return ;
    }

    return pricePerMile / METERS_PER_MILE;
  }


}


angular
  .module('bringoz.admin.commons')
  .service('bringozUnitConversionService', BringozUnitConversionService);

